<template>
  <div id="gear-compare">
    <div class="row">
      <div class="col-xl-6 col-sm-12 mb-sm-3">

        <div class="row">
          <div class="col-12">
            <GearSetup :monster="monster" :player="player" :setup="setOne" @setClone="cloneSetOne"
                       @update="(set) => {this.setOne = set; this.save()} "></GearSetup>
          </div>

          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <ResultSet :monster="monster" :player="player" :setup="setOne"></ResultSet>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--      BEGIN SET 2-->

      <div class="col-xl-6 col-sm-12 mb-sm-3">
        <div class="row">
          <div class="col-12">
            <GearSetup :monster="monster" :player="player" :setup="setTwo" @setClone="cloneSetTwo"
                       @update="(set) => {this.setTwo = set; this.save()} "></GearSetup>
          </div>

          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <ResultSet :monster="monster" :player="player" :setup="setTwo"></ResultSet>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import GearPreview from "./gear-selector/GearPreview";
  import EquipmentBonus from "./gear-selector/EquipmentBonus";
  import StanceSelector from "./gear-selector/StanceSelector";
  import GearSetup from "./gear-selector/GearSetup";
  import ResultSet from "./ResultSet";

  export default {
    name: "GearCompare",
    components: {ResultSet, GearSetup, StanceSelector, EquipmentBonus, GearPreview},
    props: {
      player: {
        type: Object,
      },
      monster: {
        type: Object,
      }
    },
    data() {
      return {
        version: 0.23,
        setOne: {
          activeSpell: null,
          activeStance: {combat_style: null},
          activeSpellbook: 'standard',
          potions: require('@/assets/data/potions/default.json'),
          prayers: {},
          equipment: {
            head: {id: 0},
            cape: {id: 0},
            neck: {id: 0},
            ammo: {id: 0},
            weapon: {
              id: 0, weapon: {
                "attack_speed": 4,
                "weapon_type": "unarmed",
                "stances": [
                  {
                    "combat_style": "punch",
                    "attack_type": "crush",
                    "attack_style": "accurate",
                    "experience": "attack",
                    "boosts": null
                  },
                  {
                    "combat_style": "kick",
                    "attack_type": "crush",
                    "attack_style": "aggressive",
                    "experience": "strength",
                    "boosts": null
                  },
                  {
                    "combat_style": "block",
                    "attack_type": "crush",
                    "attack_style": "defensive",
                    "experience": "defence",
                    "boosts": null
                  }
                ]
              }
            },
            body: {id: 0},
            shield: {id: 0},
            legs: {id: 0},
            hands: {id: 0},
            feet: {id: 0},
            ring: {id: 0},
            blowpipe_ammo: {id: 0},
          },
          settings: {
            onTask: true,
            kandarinDiary: false,
            inWilderness: false,
          },
        },
        setTwo: {
          activeSpell: null,
          activeStance: {combat_style: null},
          activeSpellbook: 'standard',
          potions: require('@/assets/data/potions/default.json'),
          prayers: {},
          equipment: {
            head: {id: 0},
            cape: {id: 0},
            neck: {id: 0},
            ammo: {id: 0},
            weapon: {id: 0, weapon: {
                "attack_speed": 4,
                "weapon_type": "unarmed",
                "stances": [
                  {
                    "combat_style": "punch",
                    "attack_type": "crush",
                    "attack_style": "accurate",
                    "experience": "attack",
                    "boosts": null
                  },
                  {
                    "combat_style": "kick",
                    "attack_type": "crush",
                    "attack_style": "aggressive",
                    "experience": "strength",
                    "boosts": null
                  },
                  {
                    "combat_style": "block",
                    "attack_type": "crush",
                    "attack_style": "defensive",
                    "experience": "defence",
                    "boosts": null
                  }
                ]}},
            body: {id: 0},
            shield: {id: 0},
            legs: {id: 0},
            hands: {id: 0},
            feet: {id: 0},
            ring: {id: 0},
            blowpipe_ammo: {id: 0},
          },
          settings: {
            onTask: true,
            kandarinDiary: false,
            inWilderness: false,
          },
        },
      }
    },
    watch: {
      setOne: function (val) {
        console.debug('saving setOne');

        this.saveSetOne();
      },
      setTwo: function (val) {
        console.debug('saving setTwo');

        this.saveSetTwo()
      }
    },
    methods: {
      loadLocalStorage: function () {
        console.log('gearCompare - loading localstorage');

        const localsetOne = JSON.parse(localStorage.getItem("osrs:compare:setOne"));
        const localsetTwo = JSON.parse(localStorage.getItem("osrs:compare:setTwo"));

        if (localsetOne !== null) {
          if (localsetOne.version !== this.version) {
            console.log('cache out of date, skipping load', [localsetOne.version, this.version]);
            return
          }

          this.setOne = localsetOne.set;
        }

        if (localsetTwo !== null) {
          if (localsetTwo.version !== this.version) {
            console.log('cache out of date, skipping load', [localsetTwo.version, this.version]);
            return
          }

          this.setTwo = localsetTwo.set;
        }
      },

      loadShare: function (id) {
        console.log('Share mode detected', id);

        //TODO Switch share input based on what id is returned
        const uri = `${process.env.API_ADDR}/share/s/${id}`;
        this.$http.get(uri).then((resp) => {
          console.log('share data returned', resp.data);

          if (resp.data.cid === "gear-setup") {
            this.setOne = JSON.parse(resp.data.data)
          }


        }).catch((resp) => {
          if (resp.data === "" || resp.status !== 200) {
            //TODO Toast notification
            // this.loadLocalStorage();
            return;
          }
        })

      },

      saveSetOne: function () {
        localStorage.setItem("osrs:compare:setOne", JSON.stringify({set: this.setOne, version: this.version}));
      },
      saveSetTwo: function () {
        localStorage.setItem("osrs:compare:setTwo", JSON.stringify({set: this.setTwo, version: this.version}));
      },

      cloneSetOne: function () {
        this.setTwo = JSON.parse(JSON.stringify(this.setOne))
      },

      cloneSetTwo: function () {
        this.setOne = JSON.parse(JSON.stringify(this.setTwo))
      },

      save: function () {
        console.log('Saving comparison sets');
        this.saveSetOne();
        this.saveSetTwo()
      },
    },
    beforeMount() {
      //TODO seed sets?

      if (this.$route.query.s) {
        this.loadShare(this.$route.query.s);
        return;
      }

      this.loadLocalStorage();

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/GearCompare.vue